export const selectAllInjuriesApplyOptions = [
  {
    label: 'Stiff and sore',
    value: 'stiffAndSore',
  },
  {
    label: 'Cuts and bruises',
    value: 'cutsAndBruises',
  },
  {
    label: 'Broken bones',
    value: 'brokenBones',
  },
  {
    label: 'Unconscious after the accident',
    value: 'unconsciousAfterTheAccident',
  },
  {
    label: 'Airlifted from scene',
    value: 'airliftedFromScene',
  },
  {
    label: 'Loss of life',
    value: 'lossOfLife',
  },
];

export const selectBonesBrokenOptions = [
  {
    label: 'Skull',
    value: 'skull',
  },
  {
    label: 'Neck',
    value: 'neck',
  },
  {
    label: 'Shoulder',
    value: 'shoulder',

  },
  {
    label: 'Arm',
    value: 'arm',
  },
  {
    label: 'Hand',
    value: 'hand',

  },
  {
    label: 'Ribs',
    value: 'ribs',

  },
  {
    label: 'Back',
    value: 'back',

  },
  {
    label: 'Leg',
    value: 'leg',

  },
  {
    label: 'Foot',
    value: 'foot',
  },
  {
    label: 'Hip',
    value: 'hip',

  },
];

export const followingApplyOptions = [
  {
    label: 'Injuries are not impacting',
    value: 'injuriesAreNotImpactingMe',

  },
  {
    label: 'Plan to speak to a doctor',
    value: 'planToSpeakToADoctor',

  },
  {
    label: 'Will be going for treatment',
    value: 'willBeGoingForTreatment',

  },
  {
    label: 'Need to take time off work',
    value: 'needToTakeTimeOffWork',

  },
];

export const wereAnyOfTheFollowingItemsDamagedOptions = [
  {
    label: 'Clothing',
    value: 'clothing',
  },
  {
    label: 'Prescription glasses',
    value: 'prescriptionGlasses',
  },
  {
    label: 'Medical device',
    value: 'medicalDevice',
  },
];

export function getTypelist(field) {
  const options = {};
  let tempOptions;
  if (field === 'selectAllInjuriesApply') {
    tempOptions = selectAllInjuriesApplyOptions;
  } else if (field === 'selectBonesBroken') {
    tempOptions = selectBonesBrokenOptions;
  } else if (field === 'followingApply') {
    tempOptions = followingApplyOptions;
  } else if (field === 'wereAnyOfTheFollowingItemsDamaged') {
    tempOptions = wereAnyOfTheFollowingItemsDamagedOptions;
  }

  tempOptions.forEach((option) => {
    options[option.value] = option.label;
  });
  return options;
}
